import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQuery, getBaseUrl } from "../config";

export enum TransactionTypeEnum {
  DEPOSIT = "deposit",
  WITHDRAW = "withdraw",
  TRANSFER = "transfer",
  PURCHASE = "purchase",
  REVERSAL = "reversal",
  DIRECT_DEBIT = "direct_debit",
}

const myHeaders = new Headers();
myHeaders.append("Content-Type", "application/json");

const requestOptions = {
  method: "GET",
  headers: myHeaders,
};

export const loadTxtypes = async () => {
  return await fetch(`${getBaseUrl()}/api/v1/tx-types`, requestOptions);
};

export const txTypeApi = createApi({
  reducerPath: "txTypeApi",
  baseQuery: createBaseQuery("/api/v1/"),
  tagTypes: ["txTypeApi"],
  endpoints: (build) => ({
    loadTxTypes: build.query<TxType[], void>({
      query: () => ({
        url: "tx-types",
        method: "GET",
      }),
    }),
  }),
});
